/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:3e7e9106-7015-47d8-8802-e282465effba",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_L7DF6b1Cx",
    "aws_user_pools_web_client_id": "4a891mpo0g9ierqgk3ifi7l8ik",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://7wym9ovzxe.execute-api.us-east-1.amazonaws.com/prod",
            "region": "us-east-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://bc2iyzcuh5g4jpu5d4czav6lna.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-epxzxjqkrfhn5kskigc2zahkpq",
    "aws_user_files_s3_bucket": "intranet-storage112219-prod",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
